export const firebaseConfig = {
  apiKey: "AIzaSyBzUSVGJnNVhJGUqXBVg1i73jODq92Z0TA",
  authDomain: "flashcard-uploads.firebaseapp.com",
  projectId: "flashcard-uploads",
  storageBucket: "flashcard-uploads.appspot.com",
  messagingSenderId: "58873052864",
  appId: "1:58873052864:web:f10a52d712e2f72438f725",
};
